import { ToMethod } from 'eurogard-pattern';
import { BaseDataSource } from './base.data-source';

export function DataSourceRefreshToMethodAdapterFactory(dataSource: BaseDataSource<unknown>) {
  return ToMethod(() => dataSource.refresh());
}
